import { Component } from '@angular/core';
// import { ChatService } from 'src/app/services/chat.service';

@Component({
  selector: 'app-ticket-raised-chat',
  templateUrl: './ticket-raised-chat.component.html',
  styleUrl: './ticket-raised-chat.component.scss',
})
export class TicketRaisedChatComponent {
  messages: any[] = [];
  ticketId: any; // Replace with the actual ticket ID
  senderId: any; // Replace with the actual sender ID
  newMessage: string;

  constructor() {}

  ngOnInit(): void {
  
    // Fetch existing messages
    this.fetchMessages();
  }

  fetchMessages(): void {
    // Simulate fetching existing messages from the server
    fetch(`http://localhost:5000/api/tickets/${this.ticketId}/messages`)
      .then((response) => response.json())
      .then((data) => {
        this.messages = data;
      })
      .catch((error) => console.error('Error fetching messages:', error));
  }

  sendMessage(): void {
    if (this.newMessage.trim()) {
      // this.chatService.sendMessage(this.ticketId, this.senderId, this.newMessage);
      // this.newMessage = ''; // Clear the input field
    }
  }
}
